var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedIndicatorBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9334 1.87192C15.6507 1.87192 19.4746 5.60275 19.4746 10.2053C19.4746 14.8078 15.6507 18.5386 10.9334 18.5386C6.21604 18.5386 2.39212 14.8078 2.39212 10.2053C2.39212 5.60275 6.21604 1.87192 10.9334 1.87192ZM14.6206 7.54525C14.5276 7.45455 14.4036 7.40052 14.2723 7.39352C14.141 7.38653 14.0117 7.42705 13.9092 7.50733L13.8656 7.54525L9.54542 11.7603L8.00116 10.2536C7.90463 10.1594 7.77476 10.1048 7.63827 10.1012C7.50178 10.0975 7.36904 10.145 7.26735 10.2339C7.16567 10.3228 7.10277 10.4464 7.09159 10.5792C7.08041 10.7119 7.1218 10.8438 7.20725 10.9478L7.24612 10.9903L9.1679 12.8653C9.26089 12.956 9.38492 13.01 9.51621 13.017C9.6475 13.024 9.77682 12.9834 9.87939 12.9032L9.92295 12.8653L14.6206 8.28192C14.6702 8.23355 14.7096 8.17613 14.7364 8.11293C14.7632 8.04973 14.777 7.98199 14.777 7.91358C14.777 7.84518 14.7632 7.77744 14.7364 7.71424C14.7096 7.65104 14.6702 7.59362 14.6206 7.54525Z",
    fill: "#50EF90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIndicatorBig);
export default __webpack_public_path__ + "static/media/completed_indicator_big.bd2567cd591ee1b92e098976239294fe.svg";
export { ForwardRef as ReactComponent };